//设置屏幕的宽度 布尔值
export const SET_MOBLIE = 'SET_MOBLIE'
// 设置要搜索的值
export const SET_SEARCHTEXT = 'SET_SEARCHTEXT'
// 用来控制DepsDat的元素，找到对应的数据
export const SET_CLICKCID = 'SET_CLICKCID'
// 设置详情页的导航的name
export const SET_DETAILSNAME = "SET_DETAILSNAME"